import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Switch, Route } from 'react-router-dom';
import { withRouter } from "react-router-dom";

import Start from './pages/start';

const Account = React.lazy(() => import('./pages/account'));
const Author = React.lazy(() => import('./pages/author'));
const Authors = React.lazy(() => import('./pages/authors'));
const Book = React.lazy(() => import('./pages/book'));
const Boek = React.lazy(() => import('./pages/boek'));
const BooksNew = React.lazy(() => import('./pages/books-new'));
const BooksTop60 = React.lazy(() => import('./pages/books-top60'));
const Category = React.lazy(() => import('./pages/category'));
const EBooks = React.lazy(() => import('./pages/ebooks-all'));
const Events = React.lazy(() => import('./pages/content/events'));
const Genres = React.lazy(() => import('./pages/genres'));
const Jobs = React.lazy(() => import('./pages/content/jobs'));
const Languages = React.lazy(() => import('./pages/languages'));
const LinkDownloadToken = React.lazy(() => import('./pages/content/link-download-token'));
const Login = React.lazy(() => import('./pages/login'));
const NewsletterSubscription = React.lazy(() => import('./pages/newsletter-subscription'));
const NewslettersOverview = React.lazy(() => import('./pages/newsletters-overview'));
const OurPublications = React.lazy(() => import('./pages/our-publications'));
const OwnBook = React.lazy(() => import('./pages/content/own-book'));
const PaymentResult = React.lazy(() => import('./pages/order/payment-result'));
const Products = React.lazy(() => import('./pages/products'));
const Register = React.lazy(() => import('./pages/register'));
const SearchAdvanced = React.lazy(() => import('./pages/content/search'));
const SearchResults = React.lazy(() => import('./pages/search-results'));
const ShoppingCart = React.lazy(() => import('./pages/shoppingcart'));
const Sitemap = React.lazy(() => import('./pages/content/sitemap'));
const WishList = React.lazy(() => import('./pages/wishlist'));
const Address = React.lazy(() => import('./pages/content/address'));
const Business = React.lazy(() => import('./pages/content/business'));
const CallMeBack = React.lazy(() => import('./pages/content/call-me-back'));
const Contact = React.lazy(() => import('./pages/content/contact'));
const Disclaimer = React.lazy(() => import('./pages/content/disclaimer'));
const EventSubscription = React.lazy(() => import('./pages/content/event-subscription'));
const Mission = React.lazy(() => import('./pages/content/mission'));
const Partner = React.lazy(() => import('./pages/partner'));
const Partners = React.lazy(() => import('./pages/content/partners'));
const PartnerAgreement = React.lazy(() => import('./pages/content/partner-agreement'));
const PartnerRegistration = React.lazy(() => import('./pages/content/partner-registration'));
const Press = React.lazy(() => import('./pages/content/press'));
const PrivacyPolicy = React.lazy(() => import('./pages/content/privacy-policy'));
const Remarks = React.lazy(() => import('./pages/content/remarks'));
const TermsConditions = React.lazy(() => import('./pages/content/terms-conditions'));
const Unsubscribe = React.lazy(() => import('./pages/content/unsubscribe'));
const VideosOverview = React.lazy(() => import('./pages/content/videos-overview'));
const SiteExplanation = React.lazy(() => import('./pages/content/site-explanation'));
const RedirectPayment = React.lazy(() => import('./components/redirect_payment'));
const Error404 = React.lazy(() => import('./pages/error/error404'));
const TestUpload = React.lazy(() => import('./pages/test/test-upload'));
const TestAbort = React.lazy(() => import('./pages/test/test-abort'));

const Routes = inject("stores") (
    observer (
        class Routes extends Component {

            constructor(props) {
                super(props);
                this.props = props;

                this.storeUi = this.props.stores.storeUi;
                this.storeOrder = this.props.stores.storeOrder;
            }

            render() {
                return (
                    <React.Fragment>
                        <Switch>
                            <Route exact 
                                path='/' 
                                component={Start}
                            />
                            <Route 
                                path='/all-books' 
                                component={Start} 
                            />
                            <Route 
                                path='/account/:tab?' 
                                component={Account} 
                            />
                            <Route 
                                path='/address' 
                                component={Address} 
                            />
                            {/* <Route path='/audiobooks' component={AudioBooks} /> */}
                            {/* <Route path='/audiobook/:sku' component={Book} /> */}
                            <Route 
                                path={[
                                    '/author/:id',
                                    '/auteur/:id'
                                ]} 
                                component={Author} />
                            <Route 
                                path='/authors' 
                                component={Authors} 
                            />
                            <Route 
                                path={[
                                    '/book/:sku/:tab?',
                                    '/boek/:sku/:tab?'
                                ]} 
                                component={Book} />
                            <Route 
                                path={[
                                    '/business', 
                                    '/zakelijk'
                                ]}
                                component={Business} />
                            <Route 
                                path={[
                                    '/call-me-back', 
                                    '/belterug',
                                    '/belmeterug'
                                ]}
                                component={CallMeBack} />
                            <Route 
                                path={[
                                    '/category/:name' , 
                                    '/categorie/:name' 
                                ]}
                                render={(routeProps) => (<Category {...routeProps} category={'category'}/>)}
                            />
                            <Route 
                                path={[
                                    '/contact', 
                                    '/vragen'
                                ]}
                                component={Contact} 
                            />
                            <Route 
                                path='/disclaimer' 
                                component={Disclaimer} 
                            />
                            <Route 
                                path='/ebooks' 
                                component={EBooks} 
                            />
                            <Route 
                                path={[
                                    '/events', 
                                    '/ontmoet-de-schrijver',
                                    '/ontmoetdeschrijver'
                                ]}
                                component={Events} 
                            />
                            <Route 
                                path={[
                                    '/inschrijving/:ref?', 
                                    '/subscription/:ref?'
                                ]}
                                component={EventSubscription} 
                            />
                            {/* <Route 
                                path='/genre/:name' 
                                component={Genre} 
                            /> */}
                            <Route 
                                path='/genres' 
                                component={Genres} 
                            />
                            <Route 
                                path={[
                                    '/jobs', 
                                    '/vacature',
                                    '/vacatures'
                                ]}
                                component={Jobs} 
                            />
                            <Route 
                                path={[
                                    '/languages/:lang?',
                                    '/taal/:lang?'
                                ]}
                                //render={(routeProps) => (<Languages {...routeProps} category={'language'}/>)}
                                component={Languages}
                            />
                            <Route
                                path='/download/:token'
                                component={LinkDownloadToken}
                            />
                            <Route 
                                path='/login' 
                                component={Login} 
                            />
                            <Route 
                                path={[
                                    '/mission', 
                                    '/missie'
                                ]}
                                component={Mission} 
                            />
                            <Route path={[
                                    '/new-books/:view?', 
                                    '/overzichtnw/:view?'
                                ]}
                                component={BooksNew} 
                            />
                            <Route 
                                path={[
                                    '/newsletter', 
                                    '/nieuwsbrief2'
                                ]}
                                component={NewsletterSubscription} 
                            />
                            <Route path={[
                                    '/overview-newsletters/:week?', 
                                    '/nieuwsbriefoverzicht/:week?'
                                ]}
                                component={NewslettersOverview} />
                            <Route 
                                path={[
                                    '/our-publications/:tab?', 
                                    '/onze-publicaties/:tab?',
                                    '/eigen-uitgaven/:tab?',
                                    '/eigenuitgaven/:tab?',
                                    '/boeken-eigen-uitgeverij/:tab?',
                                    '/boekeneigenuitgeverij/:tab?'
                                ]} 
                                component={OurPublications} />
                            <Route 
                                path={[
                                    '/own-book', 
                                    '/eigen-boek'
                                ]}
                                component={OwnBook} 
                            />
                            <Route 
                                path={[
                                '/payment-result',
                                '/payment-result/:orderid?' 
                                ]}
                                component={PaymentResult} 
                            />
                            <Route 
                                path='/partner' 
                                component={Partner}
                            />
                            <Route 
                                path={[
                                    '/partners', 
                                    '/partneruitleg'
                                ]}
                                component={Partners} 
                            />
                            <Route 
                                path='/partner-agreement' 
                                component={PartnerAgreement} 
                            />
                            <Route 
                                path='/partner-registration' 
                                component={PartnerRegistration} 
                            />
                            <Route path={[
                                    '/press', 
                                    '/pers',
                                    '/media'
                                ]}
                                component={Press} />
                            <Route 
                                path='/privacy-policy' 
                                component={PrivacyPolicy} 
                            />
                            <Route 
                                path='/products/:group?' 
                                render={(routeProps) => (<Products 
                                    {...routeProps} 
                                    group={this.storeUi.app_interface.active_product_group} 
                                    subgroup={this.storeUi.app_interface.active_subgroup} 
                                />)}
                            />
                            <Route 
                                path='/register' 
                                component={Register} 
                            />
                            <Route 
                                path='/remarks' 
                                component={Remarks} 
                            />
                            <Route 
                                path='/search-advanced' 
                                component={SearchAdvanced} 
                            />
                            <Route 
                                path='/search-results/:page?' 
                                component={SearchResults} 
                            />
                            <Route 
                                path='/site-explanation' 
                                component={SiteExplanation} 
                            />
                            <Route 
                                path='/shoppingcart/:view?' 
                                component={ShoppingCart} 
                            />
                            <Route 
                                path='/sitemap' 
                                component={Sitemap} 
                            />
                            <Route 
                                path={[
                                    '/subcategory/:name', 
                                    '/subcategorie/:name'
                                ]} 
                                render={(routeProps) => (<Category {...routeProps} category={'subcategory'}/>)}
                            />
                            <Route 
                                path='/terms-conditions' 
                                component={TermsConditions} 
                            />
                            <Route 
                                path={[
                                    '/top60'
                                ]}
                                component={BooksTop60} />
                            <Route 
                                path={[
                                    '/unsubscribe', 
                                    '/uitschrijven'
                                ]}
                                component={Unsubscribe} />
                            <Route 
                                path={[
                                    '/videos/:video?'
                                ]}
                                component={VideosOverview} 
                            />
                            <Route 
                                path={[
                                    '/videos-overview/:video?'
                                ]}
                                component={VideosOverview} 
                            />
                            <Route 
                                path='/wishlist' 
                                component={WishList} 
                            />

                              <Route 
                              path='/:slug-:isbn/:tab?' 
                              component={Boek}
                            />                         

                            <Route 
                                path='/404' 
                                component={Error404} 
                            />

                            <Route 
                                path="/payment" 
                                render={(routeProps) => (<RedirectPayment {...routeProps} loc={this.storeOrder.order_data.order_status.url} />)}
                            />

                            <Route 
                                path='/test-upload' 
                                component={TestUpload} 
                            />
                            <Route 
                                path='/test-abort' 
                                component={TestAbort} 
                            />

                            <Route 
                                component={Error404} 
                            />
                        </Switch>
                    </React.Fragment>
                );
            }
        }
    )
)

export default withRouter(Routes);
